// @flow
import Select from './Select';
import type { SelectProps, SelectOption } from './Select';

export default Select;
export type { SelectProps, SelectOption };
